import { authHeader, handleResponse } from '../helpers';
export const DealerWiseServices = {
    GetDealerInvoicing,
    GetDealers // New service method
};

function GetDealerInvoicing(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };
   
    return fetch(`${process.env.REACT_APP_API_URL}UserDMaster/GetDealerInvoicing`, requestOptions)
        .then(handleResponse);
}

function GetDealers() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(`${process.env.REACT_APP_API_URL}UserDMaster/DealerName`, requestOptions) // Use the correct base URL
        .then(handleResponse);
}

// function handleResponse(response) {
//     return response.text().then(text => {
//         const data = text && JSON.parse(text);
//         if (!response.ok) {
//             const error = (data && data.message) || response.statusText;
//             return Promise.reject(error);
//         }
//         return data;
//     });
// }